import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { message } from 'antd';

import useAppSelector from 'hooks/useAppSelector';

import { Auction } from 'models/auction/Auction';
import { fetchAuction } from 'apis/auction';

import AuctionView from './AuctionView';

import { setDocumentTitle } from 'utils';
import { sendPageviewToGa4 } from 'utils/googleAnalytics4';

function AuctionDetail() {
  const { ga4Initialized } = useAppSelector((state) => state.common);

  const navigate = useNavigate();
  const { auctionId } = useParams();
  const [auction, setAuction] = useState<Auction | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchAuction(auctionId)
      .then((auction) => {
        setAuction(auction);
      })
      .catch((errMsg) => {
        if (errMsg) message.error(errMsg);
        navigate('/auctions');
      });
  }, [auctionId, navigate]);

  useEffect(() => {
    if (ga4Initialized && auction) {
      sendPageviewToGa4(setDocumentTitle(auction.title));
    }
  }, [ga4Initialized, auction]);

  return <AuctionView auction={auction} setAuction={setAuction} />;
}

export default AuctionDetail;
